import ProfileImageUpload from 'components/global/ProfileImageUpload';
import UniversalInput from 'components/global/UniversalInput';
import { handleCompanyLogoRemove, handleCompanyLogoUpload, handleSubmitCompanyEdit } from 'components/views/InvestorSettings/_helpers/investorSettings.events';
import { Button, Col, Row } from 'react-bootstrap';
import { $form, $view, $user } from 'signals/global.signals';

const Company = () => (
  <Row className="mt-24">
    <Col>
      <Row className="mb-32">
        <Col xs={12}>
          <div className="d-flex flex-column align-items-center mb-24">
            <h5 className="mb-16">Company Logo</h5>
            <ProfileImageUpload
              entityId={$user.value.organization.id}
              currentImage={$form.value.logoImage}
              defaultName={$form.value.organizationName}
              avatarColors={$form.value.logoColors}
              onImageUpload={handleCompanyLogoUpload}
              onImageRemove={handleCompanyLogoRemove}
              uploadPath="organization-assets"
              className="orgAvatarImage"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="organizationName"
            value={$form.value.organizationName}
            label="Company Name"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="email"
            value={$form.value.email}
            label="Company Email"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="phone"
            value={$form.value.phone}
            label="Company Phone"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="website"
            value={$form.value.website}
            label="Company Website"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="street"
            value={$form.value.street}
            label="Street Address"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="city"
            value={$form.value.city}
            label="City"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            type="state"
            name="state"
            value={$form.value.state}
            label="State/Province"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            type="zip"
            name="zip"
            value={$form.value.zip}
            label="Zip Code"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="country"
            value={$form.value.country}
            label="Country"
            className="mb-24"
            required
          />
        </Col>
        <Col lg={12} className="d-flex align-items-center">
          <Button
            className="fw-500 px-16 py-4 my-8 px-md-56 px-32"
            onClick={handleSubmitCompanyEdit}
            disabled={$view.value.isLoading}
          >
            {$view.value.isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default Company;
